"use client";
import {NeoAGgrid} from "@/components/table/neo-table/neo-ag-grid";
import {useNeoContext} from "@/context/neo/neo.context";
import {UserTableConfig} from "@/data";
import {getTableConfigWithAccess} from "@/libs/helper";
import type {NextPage} from "next";

interface IUsers {
  name: string;
  gender: string;
  parentName: string;
  phoneNo: string;
  destination: string;
  rfidNo: string;
  pickup: string;
  drop: string;
  userType: string;
  status: string;
}

export const Users: NextPage = function () {
  const {roleAccess} = useNeoContext();
  const data = getTableConfigWithAccess(roleAccess, UserTableConfig, "MC005");

  return (
    <div className="flex min-h-[calc(100vh-63px)] w-full flex-col px-5 py-5">
      {/* <div className="mb-4 flex-row px-3">
        <NeoHeader message={data.title}></NeoHeader>
      </div> */}
      <div className="flex-row">
        {/*<NeoTable table={data.table}></NeoTable>*/}
        <NeoAGgrid table={data.table}></NeoAGgrid>
      </div>
    </div>
  );
};
